export default __webpack_public_path__ + "static/media/piqr-qr.23bdd6f1.png";